import { IApplicationState } from '../../types/redux';
import { checkFsk } from './checkFsk';
import { getFsk } from './getFsk';

export function introductionDisclaimerSelector(state: IApplicationState): string | null {
  const isFSK = checkFsk(state);
  const fskContent = getFsk(state);
  const disclaimer = fskContent?.mainLandingBanner?.disclaimer;

  if (isFSK && disclaimer) {
    return disclaimer;
  }

  return null;
}
